import { Box, Flex, Text, Input, FormControl, FormLabel, Link, Image, FormErrorMessage, InputGroup, InputLeftAddon, InputRightAddon, InputRightElement, Spinner, HStack, PinInput, PinInputField } from '@chakra-ui/react';
import Logo from "../../assets/images/hrms_logo.svg";
import MyDiv from './forgotPassword.style';
import { CustomButton, CustomToast } from '../../components';
import * as routesNames from '../../constants/routes';
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import { useFetch } from '../../hooks/useFetch';
import Sdlc from "../../assets/images/sdlc.svg";

const ForgotPassword = () => {
    const { addToast } = CustomToast();
    const [email, setEmail] = useState('');
    const [otp, setOtp] = useState('');
    const { fetchApi, loading } = useFetch(addToast);
    const navigate = useNavigate();
    const [otpSent, setOtpSent] = useState(false);
    const [timer, setTimer] = useState(60);
    const [canResend, setCanResend] = useState(false);
    const [otpAttempts, setOtpAttempts] = useState(0);
    const handlesendOtp = async () => {
        if (!email) {
            addToast({ message: "Please enter your email", status: "error" });
            return;
        }
        const response = await fetchApi("User/forgotpassword", "POST", { email }, "", "");
        if (response) {
            addToast({ message: response.message, status: "success" });

            setOtpSent(true);
            setTimer(60);
            setCanResend(false);
            setOtp("");
             setOtpAttempts(0);
        }
    }
    const handleverifyOtp = async (e: React.FormEvent) => {
        e.preventDefault();
       if (!otp || otp.length !== 6) {
    addToast({
        message: "Please enter a 6-digit OTP",
        status: "error",
    });

    setOtp("");

    return;
}

         if (otpAttempts >= 3) {
        addToast({
            message: "Maximum OTP attempts exceeded. Please request a new OTP.",
            status: "error",
        });
          setOtp("");
        return;
    }

        const payload = { Email: email, OTP: otp };
        const response = await fetchApi("User/verifyotp", "POST", payload, "", "");
        if (response?.success) {
            navigate(routesNames.RESETPASSWORD, {
                state: { email },
            });
        } else {
            const attempts = otpAttempts + 1;

        setOtpAttempts(attempts);
        setOtp("");

        if (attempts >= 3) {
            addToast({
                message: "Maximum OTP attempts reached. Please request a new OTP.",
                status: "error",
            });

            setOtpSent(false);
            setCanResend(true);
        } 
        }
    };

    useEffect(() => {
        let interval: ReturnType<typeof setInterval>;

        if (otpSent && timer > 0) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        }

        if (timer === 0) {
            setCanResend(true);
        }

        return () => clearInterval(interval);
    }, [otpSent, timer]);

    return (
        <MyDiv>
            <Box className="login-container">
                <Flex className="login-flex-wrapper">
                    <Box className="login-left">
                        <Image src={Logo} alt="HRLENSE Logo" className="login-logo" />
                        <Box className="login-left-content" >
                            <Text className="login-heading font-poppins text_bold text_5xl txt common_color">Forgot Password</Text>
                            <Text className="login-subheading font-poppins text_regular text_xl low_txt font_dark">{"We will send you a OTP to Create a\nnew one."}</Text>
                        </Box>
                        <Image src={Sdlc} alt="SDLC Illustration" className="login-illustration" />
                    </Box>
                    <Box className="login-right">
                        <Box className="login-card">
                            <Text className='login-title font-poppins text_semibold text_xl font_dark'>Please enter your Email to Reset Password</Text>
                            <form
                                onSubmit={handleverifyOtp}
                            >
                                <Box className="form-group">
                                    <FormControl id="email" >
                                        <FormLabel className='font-poppins text_medium text_md font_dark'>Email</FormLabel>
                                        <InputGroup>
                                            <Input
                                                type="email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}

                                                className="input text_regular font-poppins text_sm font_dark"
                                                placeholder="Please Enter Your Email"
                                            />
                                            <InputRightElement width="fit-content" pr={3}>
                                                <Text
                                                    as="button"
                                                    type='button'
                                                    className='font-poppins text_sm text_medium'
                                                    color="black"
                                                    textDecoration="underline"
                                                    cursor="pointer"
                                                    onClick={handlesendOtp}
                                                    disabled={loading}
                                                >
                                                    {loading ? (
                                                        <Spinner size="xs" color="green.500" />
                                                    ) : otpSent ? (
                                                        canResend ? (
                                                            "Resend OTP"
                                                        ) : (
                                                            `Resend in ${timer}s`
                                                        )
                                                    ) : (
                                                        "Send OTP"
                                                    )}
                                                </Text>
                                            </InputRightElement>
                                        </InputGroup>
                                        <FormErrorMessage></FormErrorMessage>
                                    </FormControl>
                                </Box>
                                <Box className="form-group">
                                    <FormControl id="otp">
                                        <FormLabel className="font-poppins text_medium text_md font_dark">OTP</FormLabel>
                                        <Flex justifyContent="center" gap={3} className="otp_box">
                                            <PinInput otp value={otp} onChange={(value) => setOtp(value)}  isDisabled={!otpSent || otpAttempts >= 3} type="number">
                                                <PinInputField />
                                                <PinInputField />
                                                <PinInputField />
                                                <PinInputField />
                                                <PinInputField />
                                                <PinInputField />
                                            </PinInput>
                                        </Flex>
                                        <FormErrorMessage></FormErrorMessage>
                                    </FormControl>
                                </Box>
                                <Box className="form-group">
                                    <CustomButton type="submit" title="Next" className='login-button font-poppins btn_theme:hover btn_theme' isDisabled={!otp} />
                                </Box>
                            </form>
                        </Box>
                    </Box>
                </Flex>
            </Box>
        </MyDiv>
    )
}
export default ForgotPassword;
